import React from "react";
import styles from "./things-hub-cards.modules.scss";
import { useSortable } from "@dnd-kit/react/sortable";
import { DragDropProvider } from "@dnd-kit/react";
import { HomepageCard } from "@src/components/molecules/homepage-card/homepage-card";

const cssClassName = "things-hub-cards";

const Sortable = ({
  id,
  index,
  card,
  isDragMode,
}: {
  id: string | number;
  index: number;
  card: HomepageCard;
  isDragMode: boolean;
}) => {
  const { ref, handleRef } = useSortable({ id, index, disabled: !isDragMode });
  return (
    <HomepageCard
      ref={ref}
      handleRef={handleRef}
      card={card}
      isDragMode={isDragMode}
    />
  );
};
interface ThingsHubCardsProps {
  cards: HomepageCard[];
  isDragMode: boolean;
  handleDragEnd: (event: any) => void;
}

export const ThingsHubCards = ({
  cards,
  isDragMode,
  handleDragEnd,
}: ThingsHubCardsProps) => {
  return (
    <DragDropProvider onDragEnd={handleDragEnd}>
      <div className={styles[`${cssClassName}`]}>
        {cards?.map((card, index) => (
          <Sortable
            key={card.id}
            id={card.id}
            index={index}
            isDragMode={isDragMode}
            card={card}
          />
        ))}
      </div>
    </DragDropProvider>
  );
};
